import classNames from 'classnames';
import AppDownloadLinks, { Platforms } from 'components/AppDownloadLinks/AppDownloadLinks';
import { useTranslation } from 'react-i18next';
import { GTM, GTMElements, GTMLocations } from 'utils/analytics';

type Props = {
  linksLocation?: string;
  GTMLocation?: GTMLocations;
  className?: string;
};

const AppStoreLinksBanner = (props: Props) => {
  const { t } = useTranslation();
  const { linksLocation, GTMLocation, className } = props;

  // Track if app download links were clicked
  const onPlatformLinkClick = (platform: string, subLocation: string) => {
    GTM.elementClicked(platform === Platforms.ANDROID ? GTMElements.PLAYSTORE_LINK : GTMElements.APPSTORE_LINK, GTMLocation, {
      element_sub_location: subLocation,
    });
  };

  return (
    <div className={classNames('appstore-links-banner', className)}>
      <div className="appstore-links-banner_content">
        <div className="appstore-links-banner_content-inner">
          <h2>{t('components.appstore-links-banner.title')}</h2>
          <p>{t('components.appstore-links-banner.description')}</p>
          <div className="appstores-links-holder">
            <AppDownloadLinks onLinkClick={onPlatformLinkClick} linksLocation={linksLocation} />
            <img src={t('components.appstore-links-banner.qr-code-src')} alt="" className="appstore-links-banner-qrcode" />
          </div>
        </div>
      </div>
      <div className="appstore-links-banner_image">
        <img src={t('components.appstore-links-banner.hand-app-src')} alt="" className="appstore-links-banner-handapp" />
      </div>
    </div>
  );
};

export default AppStoreLinksBanner;
